export const redProtectonColor = '#FF0000'
export const greenProtectonColor = '#008000'
export const blueProtectonColor = '#0000FF'
export const orangeProtectonColor = '#FF681F'